module.exports = __webpack_public_path__ + "static/img/takaradani.b655d51.jpg";